import React from "react";
import type { FC } from "react";

export const IEStyles: FC = () => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `<!--[if IE]>
              <style>
                .for-ie-buttons {
                  height: 300px;
                },
                .for-ie-buttons::before {
                    margin-right: -26px;
                }
              </style>
            <![endif]-->`,
      }}
    ></div>
  );
};
